import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'signup-success-form',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './signup-success-form.component.html',
  styleUrl: './signup-success-form.component.scss',
})
export class SignupSuccessFormComponent implements OnInit{
  @Input('appName') appName!: string;
  @Output('navigateToSignupVerify') navigateToSignupVerifyEvent = new EventEmitter<void>();
  logoUrl = ``
  backgroundImageId = ``
  navigateToSignupVerify() {
    this.navigateToSignupVerifyEvent.emit();
  }

  ngOnInit(): void {
    if(this.appName == "arenaEqApp"){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
    }
  }
}
